import {
  prisma,
  IntegrationOperationType,
  IntegrationServiceType,
  Prisma,
} from "client";
import type { IntegrationLogEntityRef } from "./entity";

export * from "./entity";

export type LogIntegrationCallInput = {
  service: IntegrationServiceType;
  operation: IntegrationOperationType;
  url: string;
  request: Prisma.InputJsonValue;
  response: Prisma.InputJsonValue;
  statusCode: number;
  createdById?: string;
  /** Polymorphic link to the business entity that triggered this call. */
  entity?: IntegrationLogEntityRef | null;
};

export const logIntegrationCall = async ({
  service,
  operation,
  url,
  request,
  response,
  statusCode,
  createdById,
  entity,
}: LogIntegrationCallInput) => {
  try {
    await prisma.integrationLog.create({
      data: {
        service,
        operation,
        url,
        request,
        response,
        statusCode,
        createdById: createdById ?? "",
        ...(entity?.entityType && entity?.entityId
          ? {
              entityType: entity.entityType,
              entityId: entity.entityId,
            }
          : {}),
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export type GetIntegrationLogsByEntityOptions = {
  service?: IntegrationServiceType;
  operation?: IntegrationOperationType;
  limit?: number;
  cursor?: string;
};

export const getIntegrationLogsByEntity = async (
  entityType: string,
  entityId: string,
  options: GetIntegrationLogsByEntityOptions = {}
) => {
  const { service, operation, limit = 50, cursor } = options;

  return prisma.integrationLog.findMany({
    where: {
      entityType,
      entityId,
      ...(service ? { service } : {}),
      ...(operation ? { operation } : {}),
    },
    orderBy: { createdAt: "desc" },
    take: limit,
    ...(cursor
      ? {
          skip: 1,
          cursor: { id: cursor },
        }
      : {}),
  });
};

export const countIntegrationLogsByEntity = async (
  entityType: string,
  entityId: string,
  options: Pick<GetIntegrationLogsByEntityOptions, "service" | "operation"> = {}
) => {
  const { service, operation } = options;

  return prisma.integrationLog.count({
    where: {
      entityType,
      entityId,
      ...(service ? { service } : {}),
      ...(operation ? { operation } : {}),
    },
  });
};
